<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top:4rem;">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div v-if="ar != null">
      <cabecalho :ar="ar"></cabecalho>
      <div class="app-content">
        <b-card
          class="shadow-sm mb-2 bg-white rounded"
          v-for="template in ar.certificateTemplates"
          v-bind:key="template.id"
          v-bind:title="template.name"
          tag="article"
        >
          <b-card-text>{{template.description}}</b-card-text>

          <router-link
            class="btn-sd"
            :to="{path: '/order/' + template.id}"
            style="float:right"
          >Solicitar</router-link>
        </b-card>
      </div>
    </div>
    <b-alert v-model="showErro" variant="danger">{{mensagemErro}}</b-alert>
  </div>
</template>

<script>
import cabecalho from "./components/Cabecalho.vue";

export default {
  components: {
    cabecalho
  },
  name: "app",
  data() {
    return {
      ar: null,
      mensagemErro: null,
      showErro: false,
      loading: false
    };
  },
  created() {
    this.obterCertificados();
  },
  methods: {
    obterCertificados: function() {
      this.showErro = false;
      this.loading = true;
      this.$http
        .get(
          this.$serviceUrl + "/registerauthority/" + this.$route.params.arName
        )
        .then(
          resp => {
            this.ar = resp.body;
            document.body.style.setProperty('--main-color', this.ar.mainColor);
            document.body.style.setProperty('--main-color-darker-alpha8', this.ar.mainColorDarkerAlpha8);
            document.body.style.setProperty('--main-color-darker-alpha2', this.ar.mainColorDarkerAlpha2);
            this.loading = false;
          },
          resp => {
            if (resp.status == 404) {
              this.mensagemErro = "Autoridade de Registro não encontrada.";
            } else {
              this.mensagemErro = resp.body.message;
            }
            this.showErro = true;
            this.loading = false;
          }
        );
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/App.vue